<template>
  <section class="business-info">
    <!-- <div :style="{backgroundImage:'url(' + businessImgUrl + ')'}" class="bgc"></div> -->
    <img :src="businessImgUrl" alt="">
    <h3 class="business-name">{{businessName}}</h3>
  </section>
</template>

<script>

  // import axios from 'axios'

  export default {
    name: 'business-info',
    props: {
      businessImgUrl: {
        type: String,
        required: false,
      },
      businessName: {
        type: String,
        required: false,
      },
    },
    data() {
      return {

      }
    },
    components: {

    },
    methods: {

    }
  }
</script>

<style scoped lang="less">
  @import '../../style/variable.less';

  .business-info {
    position: relative;
    .shadow(10px,0,5px,rgba(0,0,0,.2));
    // .radius(8px);
    img{
      display: block;
      // .margin-Tb(.4rem);
      .wh(100%,3.8rem);
      .shadow(5px);
      opacity: .6;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      // .radius(50%);
    }
    .business-name{
      font-size: .6rem !important;
      text-align: center;
      font-weight: 600;
      white-space:nowrap;
      line-height: 1.2rem;
      padding: 0 20px;
      color: #fff;
      position:absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      margin: 0 auto;
      text-shadow: 0 0 3px #E77618;
      box-shadow: 0 0 3px #888;
      &::before{
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #E77618;
        opacity: .6;
        z-index: -1;
      }
    }
    // .bgc{
    //   position: absolute;
    //   background: no-repeat center/100% 100%;
    //   filter: blur(2px);
    //   top: 0;
    //   left: 0;
    //   bottom: 0;
    //   right: 0;
    //   opacity: 0.8;
    //   // z-index: 1;
    // }
  }
</style>



// WEBPACK FOOTER //
// src/components/child-components/publicBusinessInfo.vue